import Store from 'lightningjs-redux';
import { getCurrentLayout } from '../../logic/layout/layout.selectors';
import {
  getCanPlay,
  getCurrentMetadataItem,
  getIsBuffering,
  getPlaybackState,
  getSideGlassContent,
} from '../../logic/player/player.selectors';

const mapControllers = instance => [
  {
    selector: getPlaybackState,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.playbackState = value;
    },
  },
  {
    selector: getCurrentLayout,
    shouldBeInvokedOnConnect: true,
    callback: () => {
      instance.start();
    },
  },
  {
    selector: getCanPlay,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.canPlay = value;
    },
  },
  {
    selector: getCurrentMetadataItem,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.metadata = value;
    },
  },
  {
    selector: getSideGlassContent,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.hasRelatedEpisodes = Boolean(value);
    },
  },
  {
    selector: getIsBuffering,
    shouldBeInvokedOnConnect: false,
    callback: value => {
      instance.isBuffering = Boolean(value);
    },
  },
];

export default Store.control(mapControllers);
